<template>
  <div>
    <page-header
      has-return
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
      class="mt-3 mt-md-0"
      @onReturn="onReturn"
    />

    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import AcademicYearServices from '@/services/api/academicyear.api';
import codeAcademicYear from '@/utils/constants/codeAcademicYear.js';
import LocationServices from '@/services/api/location.api';
import ReportServices from '@/modules/report/api';
import DocumentServices from '@//modules/report/document';
import referralAndEquipmentsservice from '@/services/api/referralsandequipments.api';
export default {
  name: 'Referral',
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    model: {
      search: {
        filters: {
          academicYear: null,
          caat: null,
          municipality: null,
          school: null,
          status: null,
          referralType: null,
        },
        collections: {
          academicYears: [],
          caats: [],
          municipalities: [],
          schools: [],
          statuses: [],
          referralTypes: [],
        },
      },
    },
  }),
  computed: {
    headerConfig() {
      return {
        title: 'Informe de Referidos',
        icon: 'fa-solid fa-list font-22 ',
        routes: ['Inicio', 'Informe de Referidos'],
      };
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Año Fiscal',
          placeholder: 'Seleccionar',
          error: 'Favor seleccionar un año fiscal.',
          validations: 'required',
          class: 'col-md-4',
          clearable: false,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'caat',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'CAAT',
          placeholder: 'Seleccionar',
          class: 'col-md-4',
          options: this.model.search.collections.caats,
          value: this.model.search.filters.caat,
        },
        {
          name: 'municipality',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Municipio',
          placeholder: 'Seleccionar',
          class: 'col-md-4',
          options: this.model.search.collections.municipalities,
          value: this.model.search.filters.municipality,
          onChanged: this.onChangedMunicipality,
          disabled: this.model.search.collections.municipalities <= 1,
        },
        {
          name: 'school',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Escuela',
          placeholder: 'Seleccionar',
          class: 'col-md-4',
          options: this.model.search.collections.schools,
          value: this.model.search.filters.school,
        },
        {
          name: 'status',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Estatus',
          placeholder: 'Seleccionar',
          class: 'col-md-4',
          options: this.model.search.collections.statuses,
          value: this.model.search.filters.status,
        },
        {
          name: 'referralType',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Tipo de Referido',
          placeholder: 'Seleccionar',
          class: 'col-md-4',
          options: this.model.search.collections.referralTypes,
          value: this.model.search.filters.referralType,
        },
      ];
    },
  },
  async mounted() {
    await this.getInitialFilters();
  },
  methods: {
    async getInitialFilters() {
      await Promise.allSettled([
        this.getAcademicYears(),
        this.getReferralTypes(),
        this.getStatuses(),
        this.getCaats(),
      ]);
    },
    async getAcademicYears() {
      const { data } =
        await AcademicYearServices.getAcademicYearsFromSpecificYear(
          codeAcademicYear['2016-2017']
        );
      this.model.search.collections.academicYears = data;
    },
    async getReferralTypes() {
      const { data } = await referralAndEquipmentsservice.getReferralTypes();
      this.model.search.collections.referralTypes = data;
    },
    async getStatuses() {
      const { data } = await referralAndEquipmentsservice.getStatuses();
      this.model.search.collections.statuses = data;
    },
    async getCaats() {
      const { data } = await referralAndEquipmentsservice.getCaats();
      this.model.search.collections.caats = data;
    },
    async getMunicipalities() {
      const { data } = await LocationServices.getMunicipalities({
        academicYearId: this.model.search.filters.academicYear.id,
        centerId: this.model.search.filters.center?.id,
      });
      this.model.search.collections.municipalities = data;
    },
    async getSchools() {
      const { data } = await LocationServices.getSchools({
        academicYearId: this.model.search.filters.academicYear.id,
        municipalityId: this.model.search.filters.municipality?.id,
      });
      this.model.search.collections.schools = data;
    },
    async onChangeAcademicYear() {
      if (this.model.search.filters.academicYear)
        await this.getMunicipalities();
      else {
        this.model.search.collections.municipalities = [];
        this.model.search.filters.municipality = null;
      }
    },
    async onChangedMunicipality() {
      if (this.model.search.filters.municipality) await this.getSchools();
      else {
        this.model.search.collections.schools = [];
        this.model.search.filters.school = null;
      }
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();
      if (!isValid) return;
      await this.process();
    },
    async process() {
      try {
        const { data } = await ReportServices.getReport('referralreport', {
          academicYearId: this.model.search.filters.academicYear?.id,
          caatId: this.model.search.filters.caat?.id,
          municipalityId: this.model.search.filters.municipality?.id,
          schoolId: this.model.search.filters.school?.id,
          statusId: this.model.search.filters.status?.id,
          referralTypeId: this.model.search.filters.referralType?.id,
        });
        DocumentServices.Download(data);
      } catch {
        this.ShowToast('Error', 'Error al intentar cargar el reporte', 'error');
      }
    },
    onReturn() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped></style>
